import { render, staticRenderFns } from "./FormSetupEditSectionItem.vue?vue&type=template&id=a7e5192a"
import script from "./FormSetupEditSectionItem.vue?vue&type=script&lang=js"
export * from "./FormSetupEditSectionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports